import { getStrategyBotConstants } from '../constants';

const getStrategyBot = (state, action) => {
    if (state === undefined) {
        return {
            strategyBots: [],
            loading: true,
            error: false,
        };
    }

    switch (action.type) {
        case getStrategyBotConstants.GET_STRATEGY_BOT_REQUEST:
            return {
                strategyBots: [],
                loading: true,
                error: false,
            };

        case getStrategyBotConstants.GET_STRATEGY_BOT_SUCCESS:
            return {
                strategyBots: action.payload,
                loading: false,
                error: false,
            };

        case getStrategyBotConstants.GET_STRATEGY_BOT_FAILURE:
            return {
                strategyBots: [],
                loading: false,
                error: true,
            };

        default:
            return state;
    }
};

export default getStrategyBot;
